import store from "../../../store"
import { axiosWrapper } from "../../axios_old"

import preparePayload from "../preparePayload"

const referral = async (args) => {
	const { user, data, action, setNotification, history } = args
	try {
		let newData = {}
		if (action === "GET_ALL") {
			const { data: referralAPI } = await axiosWrapper(
				"GET",
				"referralLink",
				null,
				null,
				user.token
			)

			const referralLinks = new Map()
			referralAPI.forEach((referral) =>
				referralLinks.set(referral.codeId, {
					...referral,
					id: referral.codeId
				})
			)

			return referralLinks
		} else if (action === "CREATE") {
			newData = await preparePayload({
				user,
				schema: "referral",
				data,
				url: "referralLink"
			})
			await store.setNotification("notification", true, {
				msg: `Successfully created referral link.`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "UPDATE") {
			newData = await preparePayload({
				user,
				schema: "employee",
				data,
				url: `employee/${data.id}`
			})
			await store.setNotification("notification", true, {
				msg: `Successfully updated employee ${data.firstName} ${data.lastName}.`,
				severity: "success",
				isPersist: true
			})
		} else if (action === "DELETE") {
			await axiosWrapper(
				"DELETE",
				`referralLink/${data.id}`,
				null,
				null,
				user.token
			)
			await store.setNotification("notification", true, {
				msg: `Successfully removed referral link.`,
				severity: "success",
				isPersist: true
			})
		}
		history && history(-1)
		return newData
	} catch (err) {
		console.error(err)
		await setNotification("notification", true, {
			msg: err.response?.data.message,
			severity: "error"
		})
	}
}

export default referral
